
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, SalesTaxCodeViewModel } from "@tylertech/tyler-api-types";

/**
 * SalesTaxCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class SalesTaxCodeLookupService<TDetail = unknown> {
    private readonly $apiService = inject(ApiService);
    
    AutoCalcUseTax(): Promise<boolean> {
        return this.$apiService.sendAuth("ISalesTaxCodeLookupService/AutoCalcUseTax");
    }
    CalculateUseTax(pDetail: TDetail): Promise<number> {
        return this.$apiService.sendAuth("ISalesTaxCodeLookupService/CalculateUseTax", pDetail);
    }
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<SalesTaxCodeViewModel[]>> {
        return this.$apiService.sendAuth("ISalesTaxCodeLookupService/Lookup", pCriteria);
    }
}
